<template>
    <div class="layout layout-prev">
      <div class="title-wrapper"><span class="title title-left">季度空置率环比变化top10城市</span></div>
      <div class="charts">
        <div class="charts-left">
          <top-city-chart
            :data="vacantUp.values"
            :city="vacantUp.names"
          />
        </div>
        <div class="charts-line"></div>
        <div class="charts-right">
          <top-city-chart
              :rotate="true"
              :data="vacantDown.values"
              :city="vacantDown.names"
          />
        </div>
      </div>
    </div>
    <div class="layout layout-next">
      <div class="title-wrapper"><span class="title title-right">季度预估有效租金环比变化top10城市</span></div>
      <div class="charts">
        <div class="charts-left">
          <top-city-chart
              :data="effectiveUp.values"
              :city="effectiveUp.names"
          />
        </div>
        <div class="charts-line"></div>
        <div class="charts-right">
          <top-city-chart
              :rotate="true"
              :data="effectiveDown.values"
              :city="effectiveDown.names"
          />
        </div>
      </div>
    </div>
</template>

<script setup>
import TopCityChart from "@/view/components/topCityChart.vue";
import {computed} from "vue";

const props = defineProps({
    vacantUp: Array,
    vacantDown: Array,
    effectiveUp: Array,
    effectiveDown: Array
})

const vacantUp = computed(() => getNamesAndValues(props.vacantUp, 'city', 'metricValueMOM'))
const vacantDown = computed(() => getNamesAndValues(props.vacantDown, 'city', 'metricValueMOM'))
const effectiveUp = computed(() => getNamesAndValues(props.effectiveUp, 'city', 'metricValueMOM'))
const effectiveDown = computed(() => getNamesAndValues(props.effectiveDown, 'city', 'metricValueMOM'))
function getNamesAndValues(v1, v2, v3){
  const names = [];
  const values = [];
  v1.forEach(e => {
    names.push(e[v2]);
    values.push(e[v3]);
  })
  return { names, values }
}

</script>

<style scoped>

.layout{
  position: relative;
  padding: 25px 20px;
  box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
  border-radius: 10px;
  background: #fff;
  margin-top: 20px;
  box-sizing: border-box;
}

.layout-prev{
  background: #fffef5 url("../../assets/images/top_bg1.png") no-repeat right bottom;
}

.layout-next{
  background: #f4faff url("../../assets/images/top_bg2.png") no-repeat right bottom;
}

.title{
  color: #333;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 20px;
}

.title-wrapper{
  margin-top: -26px;
  text-align: center;
  padding: 10px 20px;
}

.title-left{
  background-color: #ffd835;
}

.title-right{
  background-color: #24b7ff;
}

.charts{
  display: flex;
  box-sizing: border-box;
  margin-top: 40px;
  justify-content: center;
}

.charts-left, .charts-right{
  flex: 1;
  position: relative;
  right: 0;
}

.charts-line{
  width: 3px;
  height: 480px;
  margin: 0 20px;
  background-color: #e8e8e8;
}
</style>